import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UploadExamCenterService } from '../../shared/services/upload-exam-center/upload-exam-center.service';
import { Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert/alert.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-upload-exam-center',
  templateUrl: './upload-exam-center.component.html',
  styleUrls: ['./upload-exam-center.component.scss']
})
export class UploadExamCenterComponent implements OnInit {

  fileType: any = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  dataAvailable = false;
  dataCount: any;
  uploadType: any = "import";
  error: any;
  private _error = new Subject<string>();
  errorMessage = null;
  successMessage = null;
  uploadexamcenterdata: any;
  sender = "upload-exam-center";
  errorOnly = false;
  errorCount = 0;
  showAll = true;


  constructor(
    private router: Router,
    private uploadExamCenterService: UploadExamCenterService,
    private alertService: AlertService) { }

  ngOnInit() {
  }

  ondocImport(e) {
    this.uploadexamcenterdata = e;
    this.errorCount = 0;

    for (var i = 0; i < this.uploadexamcenterdata.length; i++) {
      if (this.uploadexamcenterdata[i].errors.length > 0) {
        this.errorCount += 1;
        this.alertService.err(this.sender, this.uploadexamcenterdata[i].errors);
      }
    }

    if (this.uploadexamcenterdata.length > 0) {
      this.dataAvailable = true;
      this.dataCount = this.uploadexamcenterdata.length;
    }
    else {
      this._error.next("Data not found!!");
    }
  }

  getData() {

    var data = [];

    if (!this.uploadexamcenterdata) {
      return data;
    }


    if (this.showAll) {
      return this.uploadexamcenterdata;
    }
    for (var i = 0; i < this.uploadexamcenterdata.length; i++) {
      var d = this.uploadexamcenterdata[i];
      if (this.errorOnly && d.errors.length > 0) {
        data.push(d);
      } else if (!this.errorOnly && d.errors.length == 0) {
        data.push(d);
      }
    }

    return data;
  }


  onConfirm() {
    if (this.errorCount > 0) {

      this.alertService.err(this.sender, "Fix all errors and try again");
      return;

    }
    this.uploadExamCenterService.saveUploadedExamCenter(this.uploadexamcenterdata)
    .pipe(first())
    .subscribe(res => {
      this.dataAvailable = false;

      if (res["status"] == "error") {
        this.alertService.err(this.sender, res["message"]);
        return;
      }


      this.alertService.show(this.sender, "File uploaded successfully");
      setTimeout(() => {


      this.router.navigate(['exam']);
    }, 1000);


    });
  }

  ondocError(e) {
    this.error = e;
  }
}
